import Cookies from "js-cookie"
import { html, render } from "lit-html"
import { repeat } from "lit-html/directives/repeat"
import { virtual, useRef, useState } from "haunted"
import markdown from "../utils/markdown"
import Modal from "../generic/modal"
import { ref } from "../directives"
import { ROLE_ICON_MAP } from "../constants"

const MODAL_TITLE_ID = "assignment-app-form-title"

export const AssignmentAppForm = ({
  title,
  action,
  prefix,
  categories,
  values,
  cancel,
  legal_fields,
  onCancel,
  onSubmit = null,
}) => {
  const formPrefix = prefix ? `${prefix}-` : ``
  return html`<form
    method="POST"
    action=${action}
    class="scroll-y-no-scrollbar md:min-w-570"
  >
    <div class="detail-card relative p-0">
      <header class="modal-header">
        <h1 id="${MODAL_TITLE_ID}" class="text-xl font-bold">${title}</h1>
        <div class="ml-4 flex flex-row">
          <button
            type="button"
            class="button mr-2 close-modal"
            @click=${onCancel}
          >
            Cancel
          </button>
          <button type="submit" class="button button-submit" @click=${onSubmit}>
            Submit
          </button>
        </div>
      </header>
      <div class="content p-5">
        <input
          type="hidden"
          name="csrfmiddlewaretoken"
          value=${Cookies.get("csrftoken")}
        />
        ${cancel
          ? html`<label class="font-bold flex flex-row items-center">
              <input
                type="checkbox"
                name="${formPrefix}cancel"
                id="id_${formPrefix}cancel"
              />
              <span class="flex ml-4">Cancel</span>
            </label>`
          : ``}
        <label class="font-bold flex mt-6" for="">Categories</label>
        ${repeat(
          categories,
          (category) => category[0],
          ([value, label], idx) => html`<label
            class="flex flex-row items-center mt-4"
            for="id_${formPrefix}categories_${idx}"
          >
            <input
              type="checkbox"
              name="${formPrefix}categories"
              id="id_${formPrefix}categories_${idx}"
              value=${value}
              .checked=${values.includes(value)}
            />
            <div class="ml-4">
              <i
                class=${value in ROLE_ICON_MAP
                  ? ROLE_ICON_MAP[value]
                  : `fas fa-pen-alt`}
              ></i>
              <span>${label}</span>
            </div>
          </label>`
        )}
        ${legal_fields.length > 0 ? html`<hr class="divider my-8" />` : ``}
        ${repeat(
          legal_fields,
          ({ name }) => name,
          ({ name, label }) => html` <label
            class="flex flex-row items-start font-bold mt-6"
          >
            <input
              type="checkbox"
              name="${formPrefix}${name}"
              required
              id="id_${formPrefix}${name}"
            />
            <div class="ml-4">${markdown(label)}</div>
          </label>`
        )}
      </div>
    </div>
  </form>`
}

const AssignmentAppButtonForm = virtual(({ className = ``, ...props }) => {
  const buttonRef = useRef(null)
  const [open, setOpen] = useState(false)

  const onClose = () => {
    setOpen(false)

    if (buttonRef.current) {
      buttonRef.current.focus()
    }
  }

  return html`<button
      type="button"
      class="button min-w-240 link-text-color ${className}"
      ?ref=${ref(buttonRef)}
      @click=${() => setOpen(!open)}
    >
      ${props.title}
    </button>
    ${open
      ? Modal({
          children: AssignmentAppForm({ ...props, onCancel: onClose }),
          labelledBy: MODAL_TITLE_ID,
          onClose,
        })
      : ``}`
})

export default AssignmentAppButtonForm

export function renderAssignmentAppForm(el) {
  const {
    app_form: {
      id,
      title,
      action,
      prefix,
      categories,
      values,
      cancel,
      legal_fields,
    },
  } = JSON.parse(
    document.querySelector(`[type="application/json"][data-props]`).innerText
  )

  render(
    AssignmentAppButtonForm({
      id,
      title,
      action,
      prefix,
      categories,
      values,
      cancel,
      legal_fields,
    }),
    el
  )
}
